import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UIUtilityService } from 'src/app/system/utility/ui-utility.service';
import { PersonalFinanceManagementTipsDialogConfig } from '../personal-finance-management-dialog.service';
import { FinanceTips } from 'src/app/common/services/personal-finance-management/personal-finance-management-bean';
import { Router } from '@angular/router';
import { MeTipsService, RedirectData } from '../../me-tips/me-tips.service';
import { ResponsiveDesignService } from 'src/app/common/services/responsive-design/responsive-design.service';
import { AnimationOptions } from 'ngx-lottie';
import { lightbulbAnimation } from '../../../lottie/lottie-animations';
import { AnimationItem } from 'lottie-web';

@Component({
    selector: 'app-personal-finance-management-dialog',
    templateUrl: './personal-finance-management-dialog.component.html',
    styleUrl: './personal-finance-management-dialog.component.less',
    standalone: false
})
export class PersonalFinanceManagementDialogComponent implements OnInit {


  UIUtilityService: any = UIUtilityService;
  externalSettings!: any;
  msgTip: string = "";
  redirectData : RedirectData[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PersonalFinanceManagementTipsDialogConfig,
    private dialog: MatDialogRef<PersonalFinanceManagementDialogComponent>,
    private srvTips: MeTipsService,
    private router: Router,
    protected srvRpDesign: ResponsiveDesignService
  ) { }

  ngOnInit(): void {
    this.externalSettings = this.data.externalSettings;
    let tips: FinanceTips = this.data.tips;

    if (tips?.tips?.length > 0) {
      let max = tips.tips.length;
      let index = Math.floor(Math.random() * max);
      let tip = tips.tips[index];
      this.msgTip = tip.message;
      tip.action?.forEach((a : string) => { 
        let redirectData = this.srvTips.getRedirectData(a);
        if (redirectData) {
          this.redirectData.push(redirectData);
        }        
      })
    }    
  }

  // Navigate the page
  onRedirect(redirect: RedirectData) {
    this.router.navigateByUrl(redirect.route, redirect.data);
  }

  protected onGotIt(_event: MouseEvent) {
    this.dialog.close(true);
  }

  protected options: AnimationOptions = lightbulbAnimation;

  protected onAnimationCreated(animationItem: AnimationItem): void {
    // console.log(animationItem);
  }

}